
const navigation = {
  home: 'Inicio',
  sugar: 'Azúcar',
  coffee: 'Café',
  logistics: 'Logística',
  news: 'Noticias',
  contact: 'Contacto'
};

const hero = {
  title: 'Exportación de Commodities',
  subtitle: 'Azúcar y Café de Brasil al Mundo',
  description: 'Brasil es líder mundial en la producción y exportación de azúcar y café. Este sitio presenta un panorama completo sobre estos productos, sus mercados, logística de exportación y mucho más.',
  exploreSugar: 'Explorar Azúcar',
  discoverCoffee: 'Descubrir Café'
};

const features = {
  title: 'Explora Nuestras Secciones',
  description: 'Descubre información detallada sobre los procesos, mercados y logística de las principales commodities brasileñas',
  sugar: {
    title: 'Conoce el proceso de exportación del azúcar',
    description: 'Del campo al puerto: entiende cómo el azúcar brasileño llega a los mercados internacionales'
  },
  coffee: {
    title: 'Descubre los caminos del café brasileño',
    description: 'Tradición y calidad que hacen de Brasil el mayor exportador mundial de café'
  },
  logistics: {
    title: 'Entiende la logística y los barcos de carga',
    description: 'La infraestructura portuaria y de transporte que hace posible las exportaciones'
  },
  learnMore: 'Saber Más'
};

const stats = {
  title: 'Brasil en Números',
  description: 'Datos que demuestran la importancia de Brasil en el mercado mundial de commodities',
  sugarExport: 'Del azúcar producido se exporta',
  coffeeWorld: 'Del café mundial viene de Brasil',
  mainPorts: 'Principales puertos exportadores',
  countries: 'Países de destino'
};

const cta = {
  title: 'Mantente Actualizado',
  description: 'Sigue las últimas tendencias del mercado de commodities y novedades del sector',
  seeNews: 'Ver Noticias',
  contact: 'Ponte en Contacto'
};

// Sugar page translations
const sugar = {
  hero: {
    title: 'Azúcar Brasileño',
    subtitle: 'Del Campo al Puerto'
  },
  types: {
    title: 'Tipos de Azúcar Exportado',
    vhp: {
      name: 'VHP (Very High Polarization)',
      description: 'Azúcar crudo con alta polarización, ideal para refinación'
    },
    refined: {
      name: 'Refinado',
      description: 'Azúcar blanco refinado, listo para consumo'
    },
    crystal: {
      name: 'Cristal',
      description: 'Azúcar cristalizado, más común en el mercado interno'
    }
  },
  regions: {
    title: 'Principales Regiones Productoras',
    sp: {
      name: 'São Paulo',
      production: '55%',
      description: 'Mayor región productora del país'
    },
    mg: {
      name: 'Minas Gerais',
      production: '12%',
      description: 'Segunda mayor región productora'
    },
    go: {
      name: 'Goiás',
      production: '10%',
      description: 'Importante región del Centro-Oeste'
    }
  },
  process: {
    title: 'Proceso de Exportación',
    step1: {
      title: 'Cosecha de Caña de Azúcar',
      description: 'Cosecha mecanizada o manual de la caña'
    },
    step2: {
      title: 'Procesamiento en Ingenios',
      description: 'Molienda y extracción del jugo de caña'
    },
    step3: {
      title: 'Almacenamiento y Transporte',
      description: 'Almacenaje en silos y transporte vial'
    },
    step4: {
      title: 'Embarque en Puertos',
      description: 'Carga en barcos graneleros'
    }
  },
  market: {
    title: 'Mercado Internacional',
    destinations: 'Principales Destinos',
    factors: {
      title: 'Factores que Afectan los Precios',
      climate: {
        title: 'Condiciones Climáticas:',
        description: 'Sequías o lluvias excesivas afectan la producción'
      },
      oil: {
        title: 'Precio del Petróleo:',
        description: 'Influye en la producción de etanol como alternativa'
      },
      demand: {
        title: 'Demanda Mundial:',
        description: 'Crecimiento poblacional y cambios en el consumo'
      },
      exchange: {
        title: 'Tipo de Cambio:',
        description: 'Variación del dólar impacta la competitividad'
      }
    }
  },
  curiosities: {
    title: 'Curiosidades del Azúcar Brasileño',
    exported: 'De la producción brasileña se exporta',
    worldShare: 'Del azúcar mundial viene de Brasil',
    mills: 'Ingenios en operación en el país',
    hectares: 'Hectáreas de caña plantadas',
    worldRank: 'Lugar mundial en producción',
    countries: 'Países importan nuestro azúcar'
  }
};

// Coffee page translations
const coffee = {
  hero: {
    title: 'Café de Brasil',
    subtitle: 'Tradición y Calidad Mundial'
  },
  history: {
    title: 'Historia e Importancia Económica',
    worldProduction: 'Producción Mundial',
    jobs: 'Empleos Generados',
    exports: 'Exportaciones Anuales',
    importers: 'Países Importadores'
  },
  types: {
    title: 'Tipos de Café Exportados',
    arabica: {
      name: 'Arábica',
      percentage: '75%',
      description: 'Café de alta calidad, sabor suave y aromático',
      regions: 'Minas Gerais, São Paulo, Espírito Santo'
    },
    robusta: {
      name: 'Robusta (Conilon)',
      percentage: '25%',
      description: 'Café más resistente, sabor fuerte y mayor contenido de cafeína',
      regions: 'Espírito Santo, Rondônia, Bahia'
    }
  },
  states: {
    title: 'Estados Productores',
    mg: {
      name: 'Minas Gerais',
      production: '54%',
      specialty: 'Arábica de montaña'
    },
    es: {
      name: 'Espírito Santo',
      production: '23%',
      specialty: 'Conilon y Arábica'
    },
    sp: {
      name: 'São Paulo',
      production: '9%',
      specialty: 'Arábica tradicional'
    },
    ba: {
      name: 'Bahia',
      production: '8%',
      specialty: 'Conilon y cafés especiales'
    }
  },
  process: {
    title: 'Proceso de Exportación',
    step1: {
      title: 'Cosecha',
      description: 'Manual (derriça) o mecánica'
    },
    step2: {
      title: 'Secado',
      description: 'Natural en patios o artificial'
    },
    step3: {
      title: 'Beneficiado',
      description: 'Descascarado y clasificación'
    },
    step4: {
      title: 'Almacenaje',
      description: 'En sacos o contenedores'
    },
    step5: {
      title: 'Exportación',
      description: 'Embarque en puertos'
    }
  },
  market: {
    title: 'Destinos y Consumo Global',
    destinations: 'Principales Destinos',
    factors: {
      title: 'Factores de Mercado',
      quotes: {
        title: 'Cotizaciones Internacionales:',
        description: 'Bolsas de Nueva York y Londres determinan precios'
      },
      climate: {
        title: 'Condiciones Climáticas:',
        description: 'Heladas y sequías afectan significativamente los precios'
      },
      quality: {
        title: 'Calidad:',
        description: 'Cafés especiales alcanzan precios premium'
      },
      logistics: {
        title: 'Logística:',
        description: 'Costos de transporte influyen en la competitividad'
      }
    }
  },
  trends: {
    title: 'Tendencias del Mercado',
    specialty: {
      title: 'Cafés Especiales',
      description: 'Crecimiento en la demanda por cafés de origen único y métodos especiales de preparación'
    },
    certifications: {
      title: 'Certificaciones',
      description: 'Certificaciones orgánicas, Fair Trade y Rainforest Alliance'
    },
    sustainability: {
      title: 'Sostenibilidad',
      description: 'Prácticas ambientalmente responsables y socialmente justas'
    }
  }
};

// Logistics page translations
const logistics = {
  hero: {
    title: 'Logística y Transporte',
    subtitle: 'La Infraestructura Detrás de la Exportación'
  },
  ships: {
    title: 'Tipos de Barcos de Carga',
    bulk: {
      name: 'Graneleros (Bulk Carriers)',
      description: 'Barcos especializados en el transporte de productos a granel como azúcar',
      capacity: '60.000 - 200.000 toneladas'
    },
    containers: {
      name: 'Contenedores Secos',
      description: 'Transporte de café en sacos y productos empacados',
      capacity: '1.000 - 20.000 TEU'
    },
    refrigerated: {
      name: 'Contenedores Refrigerados',
      description: 'Para productos que necesitan control de temperatura',
      capacity: '200 - 2.000 TEU'
    }
  },
  ports: {
    title: 'Principales Puertos Exportadores',
    santos: {
      name: 'Puerto de Santos (SP)',
      description: 'Mayor puerto de América Latina',
      products: 'Azúcar, Café, Soja',
      capacity: '4,8 millones TEU/año'
    },
    paranagua: {
      name: 'Puerto de Paranaguá (PR)',
      description: 'Principal corredor de exportación del Sur',
      products: 'Azúcar, Soja, Maíz',
      capacity: '1,2 millones TEU/año'
    },
    vitoria: {
      name: 'Puerto de Vitória (ES)',
      description: 'Importante para minerales y café',
      products: 'Café, Azúcar, Minerales',
      capacity: '800 mil TEU/año'
    },
    itaqui: {
      name: 'Puerto de Itaqui (MA)',
      description: 'Puerta de entrada del Nordeste',
      products: 'Azúcar, Soja, Maíz',
      capacity: '600 mil TEU/año'
    }
  },
  storage: {
    title: 'Almacenes y Depósitos',
    silos: {
      name: 'Silos Graneleros',
      description: 'Almacenamiento vertical para azúcar a granel',
      capacity: '10.000 - 100.000 toneladas'
    },
    warehouses: {
      name: 'Depósitos Aduaneros',
      description: 'Almacenes para productos esperando exportación',
      capacity: '5.000 - 50.000 toneladas'
    },
    refrigerated: {
      name: 'Almacenes Refrigerados',
      description: 'Conservación de productos sensibles a la temperatura',
      capacity: '1.000 - 20.000 toneladas'
    }
  },
  transport: {
    title: 'Transporte Interno',
    modes: 'Modalidades de Transporte',
    road: {
      name: 'Carretero',
      percentage: '70%',
      description: 'Principal modalidad para transporte interno'
    },
    rail: {
      name: 'Ferroviario',
      percentage: '25%',
      description: 'Uso creciente en algunas regiones'
    },
    waterway: {
      name: 'Fluvial',
      percentage: '5%',
      description: 'Utilizado en regiones específicas'
    },
    characteristics: {
      title: 'Características del Transporte',
      distances: {
        title: 'Distancias Promedio',
        farm: 'Finca → Almacén: 50-200 km',
        warehouse: 'Almacén → Puerto: 200-800 km',
        time: 'Tiempo promedio: 2-5 días'
      },
      costs: {
        title: 'Costos Logísticos',
        percent: 'Representan 15-25% del precio final',
        fuel: 'Combustible: mayor componente',
        tolls: 'Peajes y tasas portuarias'
      },
      seasonality: {
        title: 'Estacionalidad',
        peak: 'Pico en la cosecha (may-sep)',
        demand: 'Mayor demanda de transporte',
        increase: 'Aumento en los fletes'
      }
    }
  },
  challenges: {
    title: 'Desafíos y Oportunidades',
    infrastructure: {
      title: 'Infraestructura Portuaria',
      description: 'Necesidad de modernización y ampliación de la capacidad'
    },
    costs: {
      title: 'Costos Logísticos',
      description: 'Reducción de los costos de transporte y almacenaje'
    },
    sustainability: {
      title: 'Sostenibilidad',
      description: 'Implementación de prácticas ambientalmente responsables'
    },
    digitalization: {
      title: 'Digitalización',
      description: 'Automatización y control digital de los procesos'
    }
  },
  numbers: {
    title: 'Números de la Logística',
    tonnage: 'Toneladas movimentadas/año',
    ports: 'Puertos organizados',
    terminals: 'Terminales privados',
    gdp: 'Costo logístico del PIB'
  }
};

// News page translations
const news = {
  hero: {
    title: 'Noticias y Tendencias',
    subtitle: '¿Qué Está Pasando en el Mercado de Exportación?'
  },
  market: {
    title: 'Cotizaciones en Tiempo Real'
  },
  tabs: {
    recent: 'Noticias Recientes',
    analysis: 'Análisis',
    forecasts: 'Pronósticos'
  },
  analysis: {
    title: 'Análisis de Mercado',
    positive: {
      title: 'Factores Positivos',
      climate: 'Clima favorable para próxima cosecha',
      demand: 'Demanda internacional creciente',
      infrastructure: 'Mejoras en la infraestructura logística'
    },
    challenges: {
      title: 'Desafíos',
      exchange: 'Volatilidad del tipo de cambio',
      competition: 'Competencia internacional',
      costs: 'Costos logísticos elevados'
    }
  },
  newsletter: {
    title: 'Mantente Informado',
    description: 'Recibe actualizaciones semanales sobre el mercado de commodities directamente en tu email',
    placeholder: 'Tu email',
    subscribe: 'Suscribirse'
  }
};

// Contact page translations
const contact = {
  hero: {
    title: 'Sobre el Proyecto',
    subtitle: 'Conoce nuestro equipo y ponte en contacto con nosotros'
  },
  about: {
    title: 'Quiénes Somos'
  },
  objectives: {
    title: 'Nuestros Objetivos',
    educational: {
      title: 'Educativo',
      description: 'Educar sobre los procesos de producción y exportación de las principales commodities brasileñas'
    },
    informative: {
      title: 'Informativo',
      description: 'Proporcionar datos actualizados sobre mercados, precios y tendencias del sector'
    },
    connective: {
      title: 'Conectivo',
      description: 'Conectar diferentes públicos interesados en el agronegocio brasileño'
    }
  },
  team: {
    title: 'Nuestro Equipo'
  },
  sources: {
    title: 'Fuentes de Datos',
    description: 'Utilizamos exclusivamente datos oficiales de instituciones reconocidas para garantizar la precisión y confiabilidad de la información presentada.'
  },
  form: {
    title: 'Ponte en Contacto',
    subtitle: '¿Tienes dudas, sugerencias o te gustaría contribuir? ¡Habla con nosotros!',
    name: 'Nombre Completo',
    email: 'Email',
    subject: 'Asunto',
    message: 'Mensaje',
    send: 'Enviar Mensaje',
    sending: 'Enviando...',
    success: '¡Mensaje enviado con éxito! Te contactaremos pronto.',
    error: 'Error al enviar mensaje. Inténtalo de nuevo.',
    selectSubject: 'Selecciona un asunto',
    subjects: {
      doubt: 'Duda sobre datos',
      suggestion: 'Sugerencia de mejora',
      contribution: 'Contribución con datos',
      partnership: 'Propuesta de colaboración',
      press: 'Prensa',
      other: 'Otro'
    },
    placeholder: {
      name: 'Tu nombre completo',
      email: 'tu@email.com',
      message: 'Describe tu mensaje (máximo 500 caracteres)'
    },
    charRemaining: 'caracteres restantes'
  },
  social: {
    title: 'Síguenos',
    description: 'Síguenos en las redes sociales para recibir las últimas actualizaciones sobre el mercado de commodities'
  }
};

export default {
  navigation,
  hero,
  features,
  stats,
  cta,
  sugar,
  coffee,
  logistics,
  news,
  contact
};
